import {
  FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL,
  FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_FAILURE,
  IMPORT_TAX_RATES,
  IMPORT_TAX_RATES_SUCCESS,
  IMPORT_TAX_RATES_FAILURE,
} from './types';

const initialState = {
  enabledFlagValues: [],
  countryCodes: [],
  plAccountValues: [],
  bsAccountValues: [],
  isFetchingInitialDataForAddEditModal: false,
  importingTaxRates: false,
  uploadedTaxRates: [],
};

function taxRates(state = initialState, action) {
  switch (action.type) {
    case FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL:
      return {
        ...state,
        isFetchingInitialDataForAddEditModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_SUCCESS:
      return {
        ...state,
        enabledFlagValues: action.enabledFlagValues,
        countryCodes: action.countryCodes,
        plAccountValues: action.accounts,
        bsAccountValues: action.accounts,
        isFetchingInitialDataForAddEditModal: false,
      };
    case FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_FAILURE:
      return {
        ...state,
        isFetchingInitialDataForAddEditModal: false,
      };
    case IMPORT_TAX_RATES:
      return {
        ...state,
        importingTaxRates: true,
      };
    case IMPORT_TAX_RATES_SUCCESS:
      return {
        ...state,
        importingTaxRates: false,
        uploadedTaxRates: [],
      };
    case IMPORT_TAX_RATES_FAILURE:
      return {
        ...state,
        importingTaxRates: false,
      };
    default:
      return state;
  }
}

export default taxRates;
